/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BookingIdRemarkRuleDelete,
    BookingIdRemarkRuleDeleteFromJSON,
    BookingIdRemarkRuleDeleteToJSON,
    BookingIdRemarkRuleListConfiguration,
    BookingIdRemarkRuleListConfigurationFromJSON,
    BookingIdRemarkRuleListConfigurationToJSON,
    BookingIdRemarkRuleListItemPaginationWrapper,
    BookingIdRemarkRuleListItemPaginationWrapperFromJSON,
    BookingIdRemarkRuleListItemPaginationWrapperToJSON,
    BookingIdRemarkRuleQuery,
    BookingIdRemarkRuleQueryFromJSON,
    BookingIdRemarkRuleQueryToJSON,
    BookingIdRemarkRuleState,
    BookingIdRemarkRuleStateFromJSON,
    BookingIdRemarkRuleStateToJSON,
    BookingIdRemarkRuleStateResponse,
    BookingIdRemarkRuleStateResponseFromJSON,
    BookingIdRemarkRuleStateResponseToJSON,
} from '../models';

export interface ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListDeleteRuleBulkDeleteRequest {
    bookingIdRemarkRuleDelete: Array<BookingIdRemarkRuleDelete>;
}

export interface ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListListPostRequest {
    bookingIdRemarkRuleQuery?: BookingIdRemarkRuleQuery;
}

export interface ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListUpdateStateBulkPostRequest {
    bookingIdRemarkRuleState: Array<BookingIdRemarkRuleState>;
}

/**
 * no description
 */
export class BookingIdRemarkRuleListApi extends runtime.BaseAPI {

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListDeleteRuleBulkDeleteRaw(requestParameters: ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListDeleteRuleBulkDeleteRequest): Promise<runtime.ApiResponse<Array<BookingIdRemarkRuleStateResponse>>> {
        if (requestParameters.bookingIdRemarkRuleDelete === null || requestParameters.bookingIdRemarkRuleDelete === undefined) {
            throw new runtime.RequiredError('bookingIdRemarkRuleDelete','Required parameter requestParameters.bookingIdRemarkRuleDelete was null or undefined when calling apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListDeleteRuleBulkDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemarkV2/BookingIdRemarkRuleList/DeleteRuleBulk`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.bookingIdRemarkRuleDelete.map(BookingIdRemarkRuleDeleteToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BookingIdRemarkRuleStateResponseFromJSON));
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListDeleteRuleBulkDelete(requestParameters: ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListDeleteRuleBulkDeleteRequest): Promise<Array<BookingIdRemarkRuleStateResponse>> {
        const response = await this.apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListDeleteRuleBulkDeleteRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListGetListConfigurationGetRaw(): Promise<runtime.ApiResponse<BookingIdRemarkRuleListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemarkV2/BookingIdRemarkRuleList/GetListConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingIdRemarkRuleListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListGetListConfigurationGet(): Promise<BookingIdRemarkRuleListConfiguration> {
        const response = await this.apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListGetListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListListPostRaw(requestParameters: ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListListPostRequest): Promise<runtime.ApiResponse<BookingIdRemarkRuleListItemPaginationWrapper>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemarkV2/BookingIdRemarkRuleList/List`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookingIdRemarkRuleQueryToJSON(requestParameters.bookingIdRemarkRuleQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingIdRemarkRuleListItemPaginationWrapperFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListListPost(requestParameters: ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListListPostRequest): Promise<BookingIdRemarkRuleListItemPaginationWrapper> {
        const response = await this.apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListListPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListUpdateStateBulkPostRaw(requestParameters: ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListUpdateStateBulkPostRequest): Promise<runtime.ApiResponse<Array<BookingIdRemarkRuleStateResponse>>> {
        if (requestParameters.bookingIdRemarkRuleState === null || requestParameters.bookingIdRemarkRuleState === undefined) {
            throw new runtime.RequiredError('bookingIdRemarkRuleState','Required parameter requestParameters.bookingIdRemarkRuleState was null or undefined when calling apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListUpdateStateBulkPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemarkV2/BookingIdRemarkRuleList/UpdateStateBulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.bookingIdRemarkRuleState.map(BookingIdRemarkRuleStateToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BookingIdRemarkRuleStateResponseFromJSON));
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListUpdateStateBulkPost(requestParameters: ApiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListUpdateStateBulkPostRequest): Promise<Array<BookingIdRemarkRuleStateResponse>> {
        const response = await this.apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListUpdateStateBulkPostRaw(requestParameters);
        return await response.value();
    }

}
